module.exports = __webpack_public_path__ + "media/images/flags/fi-dd9b4eb9275098b20b39c26ed070e4c2.svg";